// Dynamic API_URL configuration
// SECURITY: Only works in development mode
// In production, always uses environment variable

const getApiUrl = () => {
    // PRODUCTION: Always use environment variable (REQUIRED)
    if (process.env.NODE_ENV === 'production') {
        const apiUrl = process.env.REACT_APP_API_URL;
        
        if (!apiUrl) {
            throw new Error(
                'REACT_APP_API_URL environment variable is required in production mode. ' +
                'Please set it in your .env file or deployment configuration.'
            );
        }
        
        return apiUrl;
    }
    
    // DEVELOPMENT ONLY: Dynamic IP detection for local network testing
    const hostname = window.location.hostname;
    const isNgrokDomain = /(?:^|\.)ngrok-free\.app$|(?:^|\.)ngrok\.app$/i.test(hostname);

    // When app is opened via ngrok, route API through the same origin.
    // CRA dev server proxy then forwards /api -> localhost:5000.
    if (isNgrokDomain) {
        return `${window.location.origin}/api`;
    }
    
    // If accessing via IP address (e.g., from mobile on same network)
    // This is only for development/testing purposes
    if (/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(hostname)) {
        console.log('🔧 Development mode: Using dynamic API URL for IP:', hostname);
        return `http://${hostname}:5000/api`;
    }
    
    // Development fallback: localhost
    return process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
};

export const API_URL = getApiUrl();

// Also set it globally for backward compatibility
if (typeof window !== 'undefined') {
    window.API_URL = API_URL;
}

